import { render, staticRenderFns } from "./SelezioneMultiplaEMAdapter.vue?vue&type=template&id=23ffb670&scoped=true&"
import script from "./SelezioneMultiplaEMAdapter.vue?vue&type=script&lang=js&"
export * from "./SelezioneMultiplaEMAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffb670",
  null
  
)

export default component.exports